export enum ValueOrVariableType {
  value = 'value',
  variable = 'variable'
}
